import Profile from "../Model/Profile.ts";
import {ZapleczeApi} from "../ZapleczeApi.ts";
import GoodStatus from "../Model/GoodStatus.ts";

class GoodApi extends ZapleczeApi {

    public constructor(token: string, profile: Profile ) {
        super(token, profile);
    }

    public async goodStatusTypes(): Promise<GoodStatus> {
        const url = this.getUrl() + '/api/v1/good/statuses';
        try {
            return  await this.get<GoodStatus>(url);
        } catch (error) {
            console.error('Error fetching good status types:', error);
            throw error;
        }
    }
}

export default GoodApi;